import React from 'react';
import { MapPin, Phone, Mail, Clock, ShieldCheck } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-12 lg:py-16 bg-white" data-id="element-91">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="text-center max-w-xl mx-auto mb-10" data-id="element-93">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-94">
            Get in Touch
          </h2>
          <p className="text-charcoal/70 text-base font-medium" data-id="element-95">
            Ready to take the first step? Reach out to schedule a consultation.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-96">
          <div data-id="element-97">
            <div className="bg-olive rounded-2xl p-6 md:p-8" data-id="element-98">
              <div className="flex items-center gap-2 text-gold mb-6 text-sm font-bold uppercase tracking-wide" data-id="element-99">
                <ShieldCheck size={18} data-id="element-100" />
                HIPAA-Compliant Secure Form
              </div>
              <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-101">
                <div data-id="element-102">
                  <label htmlFor="fullName" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-103">
                    Full Name
                  </label>
                  <input type="text" id="fullName" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" required data-id="element-104" />
                </div>
                <div data-id="element-105">
                  <label htmlFor="email" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-106">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" required data-id="element-107" />
                </div>
                <div data-id="element-108">
                  <label htmlFor="phone" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-109">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base placeholder-white/30" data-id="element-110" />
                </div>
                <div data-id="element-111">
                  <label htmlFor="service" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-112">
                    Service of Interest
                  </label>
                  <select id="service" className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all min-h-[44px] font-medium text-white text-base" data-id="element-113">
                    <option value="" className="text-charcoal" data-id="element-114">
                      Select a service...
                    </option>
                    <option value="individual" className="text-charcoal" data-id="element-115">
                      Individual Counselling
                    </option>
                    <option value="couples" className="text-charcoal" data-id="element-116">
                      Couples Therapy
                    </option>
                    <option value="family" className="text-charcoal" data-id="element-117">
                      Family Therapy
                    </option>
                    <option value="trauma" className="text-charcoal" data-id="element-118">
                      Trauma Therapy
                    </option>
                    <option value="emdr" className="text-charcoal" data-id="element-119">
                      EMDR Therapy
                    </option>
                    <option value="consultation" className="text-charcoal" data-id="element-120">
                      Free Consultation
                    </option>
                  </select>
                </div>
                <div data-id="element-121">
                  <label htmlFor="message" className="block text-sm font-bold text-white/80 mb-1.5 uppercase tracking-wide" data-id="element-122">
                    Message (Optional)
                  </label>
                  <textarea id="message" rows={3} className="w-full px-4 py-3 rounded-lg border border-white/20 bg-white/10 focus:border-gold focus:ring-1 focus:ring-gold/30 outline-none transition-all resize-none font-medium text-white text-base placeholder-white/30" placeholder="Please do not include sensitive medical information." data-id="element-123"></textarea>
                </div>
                <button type="submit" className="w-full bg-gold hover:bg-gold/90 text-white px-6 py-3.5 rounded-lg font-bold text-base transition-all shadow-soft min-h-[48px] uppercase tracking-wide" data-id="element-124">
                  Request Appointment
                </button>
              </form>
            </div>
          </div>

          <div className="flex flex-col justify-center space-y-8" data-id="element-125">
            <div data-id="element-126">
              <h3 className="font-heading text-xl font-bold text-charcoal mb-5" data-id="element-127">
                Contact Information
              </h3>
              <div className="space-y-5" data-id="element-128">
                <div className="flex items-start gap-3" data-id="element-129">
                  <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-130">
                    <Phone size={18} data-id="element-131" />
                  </div>
                  <div data-id="element-132">
                    <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-133">
                      Phone
                    </p>
                    <a href="tel:5489000692" className="text-charcoal/80 hover:text-olive transition-colors font-medium text-base" data-id="element-134">
                      548-900-0692
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-135">
                  <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-136">
                    <Mail size={18} data-id="element-137" />
                  </div>
                  <div data-id="element-138">
                    <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-139">
                      Email
                    </p>
                    <a href="mailto:esther@esthermensahcounselling.com" className="text-charcoal/80 hover:text-olive transition-colors font-medium text-base break-all" data-id="element-140">
                      esther@esthermensahcounselling.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-141">
                  <div className="w-10 h-10 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-142">
                    <MapPin size={18} data-id="element-143" />
                  </div>
                  <div data-id="element-144">
                    <p className="font-bold text-charcoal mb-0.5 uppercase tracking-wide text-sm" data-id="element-145">
                      Office Location
                    </p>
                    <p className="text-charcoal/80 font-medium text-base" data-id="element-146">
                      370 Queens Avenue, London, Ontario
                    </p>
                    <div className="mt-1.5 inline-flex items-center gap-1.5 text-xs font-bold text-olive bg-olive/10 px-2.5 py-1 rounded-full tracking-wide" data-id="element-147">
                      <span className="w-1.5 h-1.5 rounded-full bg-olive animate-pulse" data-id="element-148" />
                      Telehealth Available
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-charcoal/10" data-id="element-149">
              <div className="flex items-center gap-2 mb-4" data-id="element-150">
                <Clock className="text-gold" size={20} data-id="element-151" />
                <h3 className="font-heading text-base font-bold text-charcoal" data-id="element-152">
                  Office Hours
                </h3>
              </div>
              <ul className="space-y-2 text-charcoal/80 font-medium text-base" data-id="element-153">
                <li className="flex justify-between" data-id="element-154">
                  <span data-id="element-155">Monday - Thursday</span>
                  <span className="font-bold" data-id="element-156">9:00 AM - 6:00 PM</span>
                </li>
                <li className="flex justify-between" data-id="element-157">
                  <span data-id="element-158">Friday</span>
                  <span className="font-bold" data-id="element-159">9:00 AM - 3:00 PM</span>
                </li>
                <li className="flex justify-between" data-id="element-160">
                  <span data-id="element-161">Saturday - Sunday</span>
                  <span className="font-bold text-charcoal/40" data-id="element-162">Closed</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}